import React from "react";
import { useTranslation } from "react-i18next";
import { amount, area, categoryLabel, formatDate, rangeLabel, requestTitle } from "./labels";

const STATUS_CLASS = { Active: "bg-green-700 text-white", Closed: "bg-slate-200 text-slate-800", Expired: "bg-amber-100 text-amber-900" };

// Card of a request for public and personal lists. Never receives nor shows contact details.
export default function PropertyRequestCard({ request, showStatus = false, dates, children }) {
  const { t, i18n } = useTranslation();
  const budget = rangeLabel(t, request.budgetMin, request.budgetMax, amount(t, request.transaction));
  const surface = rangeLabel(t, request.surfaceMin, request.surfaceMax, area);
  const none = t("propertyRequest.summary.none");
  return (
    <article className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm" data-request-id={request.id}>
      <div className="space-y-2 p-4 sm:p-5">
        <div className="flex flex-wrap items-center gap-2">
          {showStatus && <span className={`rounded-full px-3 py-1 text-xs font-bold ${STATUS_CLASS[request.status] || STATUS_CLASS.Closed}`}>{t(`propertyRequest.status.${request.status}`)}</span>}
          <span className="rounded-full bg-green-50 px-3 py-1 text-xs font-bold text-green-800">{t(`propertyRequest.transactionShort.${request.transaction}`)}</span>
          {(request.categories || []).map((c) => <span key={c} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-700">{categoryLabel(t, c, request.transaction)}</span>)}
        </div>
        <h3 className="break-words text-lg font-bold text-slate-900">{requestTitle(t, request)}</h3>
        <p className="text-sm text-slate-700">
          {[budget !== none && `${t("propertyRequest.summary.budget")} ${budget}`, surface !== none && `${t("propertyRequest.summary.surface")} ${surface}`].filter(Boolean).join(" · ") || none}
        </p>
        {request.freeText && <p className="line-clamp-3 whitespace-pre-line break-words text-sm italic text-slate-600">{request.freeText}</p>}
        <p className="text-xs text-slate-500">
          {dates || `${t("propertyRequest.mine.published", { date: formatDate(request.createdAt, i18n.language) })} · ${t("propertyRequest.mine.expires", { date: formatDate(request.expiresAt, i18n.language) })}`}
        </p>
      </div>
      {children}
    </article>
  );
}
